export default __webpack_public_path__ + "static/pledge_health-dd6ad9a2c332953fb505c31e41fbd20a.webp";